import Theme from '../theme';
import { moderateScale } from 'react-native-size-matters';
import { StyleSheet, Platform, Dimensions } from 'react-native';
import { scaleText } from '../utils';

const { width } = Dimensions.get('window');
export const isMobileWeb = width <= 550 && Platform.OS === 'web';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 15,
    backgroundColor: Theme.WHITE,
  },
  headerContainer: {
    paddingVertical: 10,
    ...Platform.select({
      web: {
        paddingVertical: 2,
      }
    }),
  },
  message: {
    ...Theme.textStyle.bodyCopyReg,
    textAlign: 'left',
    paddingVertical: 10,
    color: Theme.GREY_MEDIUM,
  },
  headerText: {
    fontSize: 28,
    paddingBottom: 15,
    color: Theme.GREY_DARK,
    fontFamily: Theme.Custom300,
    ...Platform.select({
      web: {
        paddingVertical: isMobileWeb ? 15 : 0,
        color: Theme.WHITE,
      },
    }),
  },
  headerTextBold: {
    fontFamily: Theme.Custom700,
    fontWeight: 'bold',
  },
  footer: {
    flex: 1,
    paddingVertical: 10,
    justifyContent: 'flex-end',
  },
  createAccountHeader: {
    ...Theme.textStyle.bodyCopyBold,
    paddingTop: 5,
    paddingBottom: 0,
    textAlign: 'center',
    ...Platform.select({
      web: {
        paddingTop: 0,
      }
    }),
  },
  freeTrialHeader: {
    fontFamily: Theme.Custom900,
    paddingVertical: 5,
    color: Theme.PRIMARY,
    textAlign: 'center',
    fontSize: moderateScale(28, 1),
    ...Platform.select({
      web: {
        paddingVertical: 0,
      }
    }),
  },
  invitationOnly: {
    fontSize: moderateScale(16, 1),
  },
  infoText: {
    ...Theme.textStyle.bodyCopyReg,
    textAlign: 'center',
    color: Theme.GREY_MEDIUM,
  },
  noInvitation: {
    ...Platform.select({
      default: {
        paddingTop: 10,
        paddingBottom: 10,
      },
      web: {
        paddingTop: 0,
        paddingBottom: 0,
      }
    }),
    fontSize: 16,
    fontFamily: Theme.Custom600,
    textAlign: 'center',
    color: Theme.GREY_MEDIUM,
  },
  link: {
    color: Theme.PRIMARY,
  },
  labelText: {
    color: Theme.GREY,
  },
  scrollViewContainer: {
    flexGrow: 1,
  },
  subFooter: {
    flex: 1,
    paddingVertical: 7,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  footerText: {
    fontSize: 14,
    fontFamily: Theme.Custom800,
    textAlign: 'center',
    color: Theme.GREY_DARK,
  },
  textHighlight: {
    fontSize: 14,
    fontFamily: Theme.Custom800,
    color: Theme.PRIMARY,
  },
  optionButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: 30,
  },
  tandcText: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.GREY_MEDIUM,
  },
});

const darkStyle = StyleSheet.create({
  textInput: {
    color: Theme.WHITE,
  },
  formErrorStyling: {
    color: Theme.RED,
    fontFamily: Theme.Custom700,
  },
  inputContainer: {
    backgroundColor: Theme.GREY_MEDIUM,
  },
})

export const textInputDarkStyle = {
  textInputStyle: darkStyle.textInput,
  errorTextStyle: darkStyle.formErrorStyling,
  placeHolderTextStyle: Theme.WHITE,
  inputContainerStyle: darkStyle.inputContainer,
}
